import React from "react";
import { Updater } from "use-immer";

import {
  CustomEventDto,
  CustomEventFeType,
} from "@intelligems/ig-types/dtos/analytics-events/custom-events";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import { CustomEventItem } from "@src/features/customEvents/components/CustomEventItem";
import Loading from "@src/utils/Loading";
import { genericAscSort, genericDescSort } from "@src/utils/sortings";

interface CustomEventListProps {
  customEvents: CustomEventDto[] | undefined;
  selectedCustomEventIds: string[];
  setSelectedCustomEventIds: Updater<string[]>;
  setIsCreating: Updater<boolean>;
  setSubpageSelected: Updater<CustomEventFeType | null>;
  setDrawerPage: Updater<string>;
}

export const CustomEventList = ({
  customEvents,
  selectedCustomEventIds,
  setSelectedCustomEventIds,
  setIsCreating,
  setSubpageSelected,
  setDrawerPage,
}: CustomEventListProps) => {
  const handleSelect = (id: string, checked: boolean) => {
    setSelectedCustomEventIds((draft) => {
      if (checked) {
        draft.push(id);
      } else {
        draft.splice(draft.indexOf(id), 1);
      }
      return draft;
    });
  };

  // todo need better handling here
  if (!customEvents) {
    return <Loading />;
  }

  return (
    <Stack
      direction={"column"}
      // marginTop={"10px"}
      spacing={5}
      sx={{ flexGrow: 1, width: "100%", overflowY: "auto" }}
    >
      {[...customEvents]
        .sort((a, b) => genericAscSort(a, b, "name"))
        .map((event: CustomEventDto) => (
          <CustomEventItem
            event={event}
            key={event.id}
            isChecked={selectedCustomEventIds.includes(event.id)}
            onSelect={handleSelect}
            setIsCreating={setIsCreating}
            setSubpageSelected={setSubpageSelected}
            setDrawerPage={setDrawerPage}
          />
        ))}
    </Stack>
  );
};
